import { Col, Image, Row, Typography } from 'antd';
import ModalC from 'src/components/Modal';
import { ISocialMedia } from 'src/interface/SocialMedia';
import ShareItem from './ShareItem';
import classes from './ShareItem.module.less';
type Props = {
  dataShareButton?: ISocialMedia[];
  visibleModal: boolean;
  setVisibleModal: (e: any) => void;
  data: any;
};
const SocialShareModal = (props: Props) => {
  return <ModalC open={props.visibleModal} hideButton={true} onCancel={() => props.setVisibleModal(false)}>
			<Typography.Title className="text-left" level={5}>
				Bagikan Ke
			</Typography.Title>
			<Row>
				<Col xs={8}>
					<Image src={props?.data?.media_images[0]?.original} loading='lazy' width={115} height={80} style={{
          borderRadius: '16px'
        }} />
				</Col>
				<Col xs={16}>
					<Typography className={classes.title}>
						{props?.data?.title}
					</Typography>
				</Col>
			</Row>
			<ShareItem className="mt-4 mb-4" label={true} />
		</ModalC>;
};
export default SocialShareModal;